import {
  setLocalStorage,
  getLocalStorage,
  removeLocalStorage,
} from './localStorageService';
import { LocalStorageKeyConstants } from '@constants/general/localStorageKeyConstants';
import { PublicRoutes } from '@enums/publicRouteEnums';
import { PrivateRoutes } from '@enums/privateRouteEnums';

const ROUTE_STORAGE_KEY = LocalStorageKeyConstants.CURRENT_ROUTE;
const MILLISECONDS_PER_SECOND = 1000;
const SECONDS_PER_MINUTE = 60;
const MINUTES_PER_HOUR = 60;
const HOURS_PER_DAY = 24;
const MILLISECONDS_PER_DAY =
  HOURS_PER_DAY *
  MINUTES_PER_HOUR *
  SECONDS_PER_MINUTE *
  MILLISECONDS_PER_SECOND;

export interface RouteState {
  path: string;
  timestamp: number;
}

export const saveCurrentRoute = async (path: string): Promise<void> => {
  if (
    path === PrivateRoutes.ROOT ||
    path === PrivateRoutes.PAYMENT_RECEIPT ||
    path === PublicRoutes.SERVICE_MAINTENANCE ||
    path.toLowerCase().includes(PublicRoutes.DEFAULT.toLowerCase())
  ) {
    return;
  }

  const routeState: RouteState = {
    path,
    timestamp: Date.now(),
  };

  await setLocalStorage(ROUTE_STORAGE_KEY, routeState);
};

export const getLastRoute = async (): Promise<RouteState | null> => {
  try {
    const stored = await getLocalStorage(ROUTE_STORAGE_KEY);
    if (!stored || typeof stored !== 'object') return null;

    const storedObj = stored as Record<string, any>;
    if (!storedObj.path || !storedObj.timestamp) return null;

    const routeState: RouteState = {
      path: storedObj.path,
      timestamp: storedObj.timestamp,
    };
    const isRecent = Date.now() - routeState.timestamp < MILLISECONDS_PER_DAY;
    return isRecent ? routeState : null;
  } catch {
    return null;
  }
};

export const clearRouteHistory = (): void => {
  removeLocalStorage(ROUTE_STORAGE_KEY);
};
